import React from 'react';
import { FieldArray } from 'formik';

import FinancialRatesSectionArray from './FinancialRatesSectionArray';
import { MultiRateSchedulerEditModel } from 'api/backofficeApiClient';

type Props = {
  children: React.ReactNode;
  renderChangesEffectiveDateBtn: () => React.ReactNode;
  onRemoveMultiRateScheduler: (index: number) => void;
  predefinedMultiRates?: MultiRateSchedulerEditModel[];
};

export default function FinancialRatesFieldArray(props: Props) {
  const {
    children,
    renderChangesEffectiveDateBtn,
    onRemoveMultiRateScheduler,
    predefinedMultiRates,
  } = props;

  return (
    <FieldArray
      name="multiRates"
      render={(props) => (
        <FinancialRatesSectionArray
          {...props}
          renderChangesEffectiveDateBtn={renderChangesEffectiveDateBtn}
          onRemoveMultiRateScheduler={onRemoveMultiRateScheduler}
          predefinedMultiRates={predefinedMultiRates}
          children={children}
        />
      )}
    />
  );
}
